import React, { Component } from 'react'
import Input from './../input'
import BVRadio from './../bvradio'
import qs from 'qs'
import { PROTOCOL } from './../../lib/helper'
import { Form } from 'formsy-react'
import _ from 'underscore'
import AdvancedOptionsForm from './../forms/advancedoptionsform'

const FORMTYPE = { FTP: 1, TOKEN: 2, HTTP: 3 }

class DreamHostForm extends Component{
	constructor(props){
		super(props)
		this.state = {currentForm: this.getCurrentFormType()}
		this.getClassName = this.getClassName.bind(this)
		this.fetchValue = this.fetchValue.bind(this)
	}

	getAppliedFilters() {
		const { history } = this.props
		const { location } = history
		return qs.parse(location.search, { ignoreQueryPrefix: true })
	}

	getCurrentFormType() {
		const { errors, migrate, httpMigrationEnabled } = this.props
		const queryParams = this.getAppliedFilters()
		let currentForm = FORMTYPE.TOKEN

		if (queryParams.http_migration || httpMigrationEnabled) {
			currentForm = FORMTYPE.HTTP
		} else if (errors.length) {
			currentForm = migrate.get('protocol') === PROTOCOL.TOKEN ? FORMTYPE.TOKEN : FORMTYPE.FTP
		}
		return currentForm
	}

	getCurrentForm() {
		const { currentForm } = this.state;
		switch (currentForm) {
			case FORMTYPE.HTTP:
				return this.httpForm();
			case FORMTYPE.TOKEN:
				return this.tokenForm();
			default:
				return this.ftpForm();
		}
	}

	fetchValue(key) {
		const { fields } = this.props
		let value = fields[key] || ""
		return value
	}

	getClassName(key) {
		const { errors } = this.props
		let classname = "col-md-12 col-xs-12"
		if (_.contains(errors, key)){
			classname += " error-field"
		}
		return classname
	}

	toggleForm(formType) {
		this.setState({currentForm: formType})
	}

	httpForm() {
		const { error } = this.props
		return (
			<div>
				{error && <div className="pb-2 mb-2 font12">{error}</div>}
				<div className="row">
					<div className={this.getClassName('bv_migration_key')}>
						<i className="mdi mdi-key"></i>
						<Input
							type="text"
							name="bv_migration_key"
							title="BV Migration Key"
							placeholder="Eg. aHR0cDovLzEyNy4wLjAuMS9zaXtTGZzQ="
							classname=""
							value={this.fetchValue('bv_migration_key')}
						/>
					</div>
				</div>
				<div className="row hide-field">
					<Input
						type="hidden"
						title=""
						name="protocol"
						placeholder=""
						classname=""
						value={PROTOCOL.HTTP}
					/>
				</div>
			</div>
		);
	}

	tokenForm() {
		const { error } = this.props
		return <div>
			<p className="pt-1 pb-2 fw-600 text-right bv-underline">
				<a onClick={() => this.toggleForm(FORMTYPE.FTP)}>Manually Input Host Details</a>
			</p>
			{ error && <div className="pb-2 mb-2 font12">{error}</div> }
			<div className="row">
				<div className={this.getClassName('migration_token')}>
					<i className="mdi mdi-key"></i>
					<a href="https://help.dreamhost.com/hc/en-us/articles/360035448951" target='_blank'
						className="position-absolute" style={{right: '15px'}}>What's this?</a>
					<Input
						type="text"
						name="migration_token"
						title="Migration Key"
						placeholder="Eg. 6LU9ECHXP7UTMZ8V"
						classname=""
						value={this.fetchValue('migration_token')}
					/>
				</div>
			</div>
			<div className="row hide-field">
				<Input
					type="hidden"
					title=""
					name="protocol"
					placeholder=""
					classname=""
					value={PROTOCOL.TOKEN}
				/>
			</div>
		</div>
	}

	ftpForm() {
		const { error } = this.props
		return <div className="pb-1">
			<p className="pt-1 pb-2 fw-600 text-right bv-underline">
				<a onClick={() => this.toggleForm(FORMTYPE.TOKEN)}>I have a Migration Token</a>
			</p>
			{ error && <div className="pb-2 mb-2 font12">{error}</div> }
			<div className="row">
				<div className={this.getClassName('newurl')}>
					<i className="mdi mdi-web"></i>
					<Input
						type="text"
						name="newurl"
						title="Destination Site URL"
						placeholder="Eg. www.google.com"
						classname=""
						value={this.fetchValue('newurl')}
					/>
				</div>
			</div>
			<div className="row">
				<div className={this.getClassName('address')}>
					<i className="mdi mdi-server"></i>
					<Input
						type="text"
						name="address"
						title="Destination Server FTP IP"
						placeholder="Eg. 127.0.0.1"
						classname=""
						value={this.fetchValue('address')}
					/>
				</div>
			</div>
			<div className="row">
				<div className={this.getClassName('type')}>
					<BVRadio
						name="type"
						title="FTP Type"
						items={['ftp', 'sftp']}
						value={this.fetchValue('type') || 'ftp'}
					/>
				</div>
			</div>
			<div className="row">
				<div className={this.getClassName('username')}>
					<i className="mdi mdi-account"></i>
					<Input
						type="text"
						name="username"
						title="FTP Username"
						placeholder="Enter FTP username here"
						classname=""
						value={this.fetchValue('username')}
					/>
				</div>
			</div>
			<div className="row">
				<div className={this.getClassName('passwd')}>
					<i className="mdi mdi-lock"></i>
					<Input
						type="password"
						name="passwd"
						title="FTP Password"
						placeholder="Enter FTP password here"
						classname=""
						value={this.fetchValue('passwd')}
					/>
				</div>
			</div>
		</div>
	}

	render() {
		const { migrate, handleSubmit, loading, error, errors, fields, params, directoryList, getDirectoryList, changeSelection,
			tablesList, getTablesList, changeTableSelection, directoriesSelectAllDisabled, allDirectoriesSelected, selectAllDirectories,
			tablesSelectAllDisabled, allTablesSelected, selectAllTables } = this.props
		const { currentForm } = this.state
		return <div className="bv-body dh">
			{loading}
			<div className="col-xs-7 col-md-4 center-dom text-center container bv-form" >
				<Form onSubmit={handleSubmit} className="bv-form-label-left-align mg-form px-15">
					<div>
						{this.getCurrentForm()}
						<div className="row hide-field">
							<Input
								type="hidden"
								name="migrate"
								value="dreamhost"
								title=""
								placeholder=""
								classname=""
							/>
							<Input
								type="hidden"
								name="nameserver"
								value="ns1.dreamhost.com"
								title=""
								placeholder=""
								classname=""
							/>
						</div>
						<AdvancedOptionsForm
							migrate={migrate}
							errors={errors}
							fields={fields}
							params={params}
							directoryList={directoryList}
							tablesList={tablesList}
							getDirectoryList={getDirectoryList}
							getTablesList={getTablesList}
							changeSelection={changeSelection}
							changeTableSelection={changeTableSelection}
							directoriesSelectAllDisabled={directoriesSelectAllDisabled}
							allDirectoriesSelected={allDirectoriesSelected}
							selectAllDirectories={selectAllDirectories}
							tablesSelectAllDisabled={tablesSelectAllDisabled}
							allTablesSelected={allTablesSelected}
							selectAllTables={selectAllTables}
						/>
						<input type="submit" value="Migrate" className="bv-primary-button"/>
					</div>
				</Form>
			</div>
		</div>
	}
}

export default DreamHostForm
